import React from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'

import { ensureExists } from '~/utils'

export const useBrandAccountId = () => {
  const { t } = useTranslation()
  const { brandAccountId } = useParams<{ brandAccountId: string | undefined }>()

  return React.useMemo(
    () => ensureExists(brandAccountId, t('assertion_failed')),
    [brandAccountId, t],
  )
}
